import * as React from 'react';
import ICustomer from '@sunbit-dev/common/models/ICustomer';

export interface IUserApplyOnline extends ICustomer {
  id: number;
}

interface IUser {
  user: IUserApplyOnline;
  ssnUpdatesStatus: boolean;
}

interface IUserAction {
  setCustomer: (setUser: Partial<IUserApplyOnline>) => void;
  switchSsnUpdates: () => void;
  reset: () => void;
}

const initialUser: IUserApplyOnline = {
  existingCustomer: false,
  addressDetails: {
    address: '',
    city: '',
    state: '',
    zipcode: '',
  },
  dateOfBirth: '',
  email: '',
  firstName: '',
  lastName: '',
  phone: '',
  ssn: '',
  yearOfBirth: '',
  id: 0,
  consumerAlertFlagActivated: false,
  emailVerified: false,
  wasCustomerMergedDuringProcess: false,
};

export const UserContext = React.createContext<IUser>({
  user: initialUser,
  ssnUpdatesStatus: false,
});

export const UserActionContext = React.createContext<IUserAction>({
  setCustomer: () => {},
  switchSsnUpdates: () => {},
  reset: () => {},
});

export const UserContextProvider = (props) => {
  const [user, setUser] = React.useState(initialUser);
  const [ssnUpdatesStatus, setSsnUpdatesStatus] = React.useState(false);

  const setCustomer = (userData) => {
    // can be one field like {phone: 23123} or multi fields
    setUser({ ...user, ...userData, existingCustomer: Boolean(userData.id) });
  };

  const switchSsnUpdates = () => {
    setSsnUpdatesStatus(true);
  };

  const reset = () => {
    setUser({ ...initialUser });
    setSsnUpdatesStatus(false);
  };

  return (
    <UserContext.Provider value={{ user, ssnUpdatesStatus }}>
      <UserActionContext.Provider value={{ setCustomer, switchSsnUpdates, reset }}>{props.children}</UserActionContext.Provider>
    </UserContext.Provider>
  );
};

export default UserContextProvider;
